module.exports = __webpack_public_path__ + "static/media/PB_Y_04.67d9905c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_04.png
// module id = 233
// module chunks = 0